import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-developer-projects',
  templateUrl: './developer-projects.component.html'
})
export class DeveloperProjectsComponent implements OnInit {

  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }
}
